<template>
  <div
    class="pb-button-group"
    :class="{
      'pb-button-group-wrappable': wrappable,
      'pb-button-group-not-wrappable': !wrappable,
      'pb-button-group-column': column,
      'pb-button-group-row': row,
      'pb-button-group-padded': padded,
    }"
  >
    <slot />
  </div>
</template>

<script setup>
defineProps({
  wrappable: { type: Boolean, default: false },
  column: { type: Boolean, default: false },
  row: { type: Boolean, default: false },
  padded: { type: Boolean, default: false },
})
</script>

<style lang="scss" src="./ButtonGroup.scss" />
